import * as React from "react";
const SvgFiBrandsVerizon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M1.741 12h3.731l3.73 8 9.326-20h3.731L11.067 24h-3.73z"
    />
  </svg>
);
export default SvgFiBrandsVerizon;
